import request from 'superagent';
import { sessionStorageItemNameAppJWT } from './sessionStorageItemNames';
import {
  addInfoBreadcrumbToSentry,
  addWarningBreadcrumbToSentry
} from './sentryErrorLogging';
import { OutdatedServerVersionError } from './errors';
import DetectServerUpdateBoundary from '../components/DetectServerUpdateBoundary';

/* Fetch the notifications every 2 minutes via Yesplan API */
const fetchNotificationsInterval = process.env.NODE_ENV === 'production' ? 120000 : 3000;

let worker;
let timer;

export const pollingFunctionViaTimer = (yesplanurl, userid, yesplanversion, callback) => {
  const requestNotifications = () => {
    request
      .get('/notifications')
      .set({
        yesplanurl,
        userid,
        yesplanversion
      })
      .set(
        'Authorization',
        `Bearer ${sessionStorage.getItem(sessionStorageItemNameAppJWT)}`
      )
      .end((error, res) => {
        if (!error) {
          if (!DetectServerUpdateBoundary.checkServerVersionNumber(res.get('Server'))) {
            /* Instead of throwing an error, perform a reject in a promise, such that the handleUnhandledRejection
              from DetectServerUpdateBoundary is triggered */
            // eslint-disable-next-line no-new
            return new Promise((resolve, reject) =>
              reject(new OutdatedServerVersionError())
            );
          }
          callback(res.body.rosternotifications, res.body.updatenotifications, res.body.timesheetnotifications);
        } else {
          addWarningBreadcrumbToSentry(
            'notifications',
            'Error in notifications polling (via timer)',
            {
              status: error.status
            }
          );
          if (error.status === 401) clearInterval(timer);
          /* Ignore other errors */
        }
      });
  };
  /* Perform one call before starting the timer */
  requestNotifications();
  return setInterval(() => {
    requestNotifications();
  }, fetchNotificationsInterval);
};

export const startPollingForNotifications = (
  yesplanurl,
  userid,
  yesplanversion,
  notificationsCallback
) => {
  if (window.Worker) {
    addInfoBreadcrumbToSentry(
      'notifications',
      'Starting notifications polling in webworker'
    );
    /* Start timer in webworker */
    worker = new Worker(new URL('./webworker.js', import.meta.url));
    worker.postMessage({
      type: 'startPollingForNotifications',
      yesplanurl,
      userid,
      yesplanversion,
      jwt: sessionStorage.getItem(sessionStorageItemNameAppJWT)
    });
    worker.addEventListener('message', (event) => {
      if (event.data.error && event.data.error === 'OutdatedServerVersionError') {
        /* Instead of throwing an error, perform a reject in a promise, such that the handleUnhandledRejection
          from DetectServerUpdateBoundary is triggered */
        // eslint-disable-next-line no-new
        return new Promise((resolve, reject) => reject(new OutdatedServerVersionError()));
      }
      notificationsCallback(
        event.data.rosternotifications,
        event.data.updatenotifications,
        event.data.timesheetnotifications
      );
    });
  } else {
    addInfoBreadcrumbToSentry(
      'notifications',
      'Starting notifications polling without webworker'
    );
    /* Start timer here */
    timer = pollingFunctionViaTimer(
      yesplanurl,
      userid,
      yesplanversion,
      notificationsCallback
    );
  }
};

export const stopPollingForNotifications = () => {
  if (worker) {
    worker.postMessage({
      type: 'stopPollingForNotifications'
    });
  } else if (timer) {
    clearInterval(timer);
  }
};

/* Send new JWT to web worker */
export const refreshJWT = (jwt) => {
  if (worker)
    worker.postMessage({
      type: 'refreshJWT',
      jwt
    });
};
